export default __webpack_public_path__ + "static/media/bladeRunner.b77e2eca.gif";